var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.date)?_c('div',{staticClass:"block"},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.formattedDate))]),_c('p',[_vm._v("Visa expiration date")])]):_c('div',{staticClass:"block block_no-date"},[_c('p',[_vm._v("Complete tasks to see visa expiration date")])])
}
var staticRenderFns = []

export { render, staticRenderFns }